import React, { useEffect } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faHeadphonesAlt } from "@fortawesome/free-solid-svg-icons";
import { convertDateTime, ImageToBase64 } from '../../../functions';
import styles from '../../../styles';
import { GroupIcons, Budge } from '../../../components';
import { global, colors } from '../../../const';
import { PrimaryTitle, PrimarySubtitle, PrimaryCaption } from '../../labels';

function ConversationGroup({ data, history }) {
    let { message, sender_nickname, time, type, group_name, sender_avatar, faces_number, unread_amount, target } = data;
    time = time === '' || !time ? null : convertDateTime(new Date(parseFloat(time) * 1000), 'list');

    useEffect(() => {
        ImageToBase64(global.MAKEURL(sender_avatar));
    }, [])

    const _navigate = () => {
        if (!target || !group_name) return;
        history.push({
            pathname: "/chat/conversation",
            search: `groupId=${target}&name=${group_name}`,
            state: { groupId: target, name: group_name }
        })
    }

    const UserAvatar = () => (
        <View>
            <Budge value={unread_amount} />
            <GroupIcons avatar={sender_avatar} faces_number={faces_number} />
        </View>
    )

    return (
        <TouchableOpacity
            activeOpacity={0.8}
            onPress={_navigate}>
            <View style={styles.chatRow}>

                <View style={{ flexDirection: "row", marginLeft: 10, alignItems: "center", width: "80%" }}>
                    <UserAvatar />
                    <View style={{ flex: 1, paddingLeft: 5 }}>
                        <PrimaryTitle
                            ellipsizeMode="tail"
                            numberOfLines={1}
                        >
                            {group_name}
                        </PrimaryTitle>
                        {
                            Number(type) === 0 && (
                                <PrimarySubtitle
                                    ellipsizeMode="tail"
                                    numberOfLines={1}
                                >
                                    {sender_nickname && sender_nickname + " : "}{message}
                                </PrimarySubtitle>
                            )
                        }
                        {
                            Number(type) === 2 && (
                                <View style={{ flexDirection: "row", alignItems: "center" }}>
                                    <PrimarySubtitle
                                        ellipsizeMode="tail"
                                        numberOfLines={1}
                                    >
                                        {sender_nickname && sender_nickname + " : "}
                                    </PrimarySubtitle>
                                    <Icon
                                        icon={faHeadphonesAlt}
                                        color={colors.midnightBack}
                                        style={{ position: "static", fontSize: 16 }}
                                    />
                                </View>
                            )
                        }
                    </View>
                </View>
                <View style={{ width: '20%', paddingTop: 8 }}>
                    <PrimaryCaption>
                        {time}
                    </PrimaryCaption>
                </View>
            </View>
            <View style={styles.divider} />
        </TouchableOpacity>
    )
}
export default withRouter(ConversationGroup);